enum ActivityStatus {
  COMPLETED = "completed",
  OVERDUE = "overdue",
  UPCOMING = "upcoming",
  UNKNOWN = "unknown",
}

export type TodaySupportedByRepActivityStatus =
  | ActivityStatus.COMPLETED
  | ActivityStatus.OVERDUE
  | ActivityStatus.UPCOMING;

export default ActivityStatus;
